module.exports = __webpack_public_path__ + "static/media/RGerstner-Regular.f3042184.ttf";